import { getNestedFieldValue } from '../components/ideaNiv/helpers/calculateImpactResults';
import { OrgFilterExtraInfoField } from './org-filter-config';

const EMPTY_VALUE_LABEL = 'N/A';

export function resolveOrgFieldFromDbPath(
  org: Record<string, unknown> | null | undefined,
  dbFieldPath: string
): unknown {
  if (!org) {
    return null;
  }

  if (dbFieldPath.startsWith('connectedOrgs.')) {
    const suffix = dbFieldPath.slice('connectedOrgs.'.length);
    if (suffix === '_id') {
      return org._id ?? null;
    }

    return org[suffix] ?? getNestedFieldValue(org, suffix);
  }

  return getNestedFieldValue(org, dbFieldPath);
}

function formatExtraInfoDisplayValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return EMPTY_VALUE_LABEL;
  }

  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return EMPTY_VALUE_LABEL;
}

export type OrgExtraInfoBadgeItem = {
  icon?: string;
  tooltip?: string;
  displayValue: string;
};

export function getOrgExtraInfoBadgeItems(
  org: Record<string, unknown> | null | undefined,
  extraInfoFields: OrgFilterExtraInfoField[]
): OrgExtraInfoBadgeItem[] {
  return extraInfoFields.map((field) => ({
    icon: field.icon,
    tooltip: field.tooltip,
    displayValue: formatExtraInfoDisplayValue(resolveOrgFieldFromDbPath(org, field.dbFieldPath)),
  }));
}

export function formatOrgFilterChipLabel(
  org: Record<string, unknown> | null | undefined,
  extraInfoFields: OrgFilterExtraInfoField[]
): string {
  const name = typeof org?.name === 'string' ? org.name : '';
  const extraValues = getOrgExtraInfoBadgeItems(org, extraInfoFields)
    .map((item) => item.displayValue)
    .filter((value) => value !== EMPTY_VALUE_LABEL);

  if (!name) {
    return extraValues.join(' · ');
  }

  if (extraValues.length === 0) {
    return name;
  }

  return [name, ...extraValues].join(' · ');
}

export function hasOrgExtraInfoFields(extraInfoFields: OrgFilterExtraInfoField[]): boolean {
  return extraInfoFields.length > 0;
}
